import { c as _c } from "react/compiler-runtime";
import { useCallback, useReducer } from 'react';
import { deploymentUrl } from '@personly/libs-urls';
import { useNotifications } from '@personly/libs-providers';
import type { PersonalPlace } from '@/statics/personals';
import { useResources } from '@/providers/resources';
type State = {
  personalPlaces: PersonalPlace[];
  count: number;
};
enum ActionType {
  PERSONAL_PLACES_FETCHED,
  PERSONAL_PLACES_CLEARED,
}
type Action = {
  type: ActionType.PERSONAL_PLACES_FETCHED;
  data: PersonalPlace[];
  count: number;
} | {
  type: ActionType.PERSONAL_PLACES_CLEARED;
};
const initialState: State = {
  personalPlaces: [],
  count: 0
};
const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.PERSONAL_PLACES_FETCHED:
      {
        return {
          ...state,
          personalPlaces: [...action.data],
          count: action.count
        };
      }
    case ActionType.PERSONAL_PLACES_CLEARED:
      {
        return {
          ...state,
          personalPLaces: [],
          count: 0
        };
      }
    default:
      return state;
  }
};
const usePersonalPlaces = () => {
  const $ = _c(7);
  const [state, dispatch] = useReducer(reducer, initialState);
  const resources = useResources();
  const {
    createNotification
  } = useNotifications();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      dispatch({
        type: ActionType.PERSONAL_PLACES_CLEARED
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const clearPersonalPlaces = t0;
  let t1;
  if ($[1] !== createNotification || $[2] !== resources) {
    t1 = async (search, languageHandle) => {
      ;
      try {
        const url = deploymentUrl("/agon/v1/guest/searchPersonalPlaces");
        url.searchParams.set("languageHandle", languageHandle);
        url.searchParams.set("search", search);
        const {
          result,
          count
        } = await resources(url);
        dispatch({
          type: ActionType.PERSONAL_PLACES_FETCHED,
          data: result,
          count
        });
      } catch (t2) {
        const e = t2;
        if (e instanceof Error) {
          const handle = e.message ?? "ERROR";
          createNotification("ERROR", handle);
        }
      }
    };
    $[1] = createNotification;
    $[2] = resources;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const searchPersonalPlaces = t1;
  let t2;
  if ($[4] !== searchPersonalPlaces || $[5] !== state.personalPlaces) {
    t2 = {
      personalPlaces: state.personalPlaces,
      searchPersonalPlaces,
      clearPersonalPlaces
    };
    $[4] = searchPersonalPlaces;
    $[5] = state.personalPlaces;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default usePersonalPlaces;